export const ESGImpactHexCodesMap = {
  insignificant: '#e2e2e2',
  veryLow: '#3caf72',
  low: '#b1fdc8',
  medium: '#e6eb57',
  high: '#fd9382',
  veryHigh: '#e34660',
};

export const ESGImpactHexBorderMap = {
  insignificant: '1px solid #919191',
  veryLow: 'none',
  low: 'none',
  medium: 'none',
  high: 'none',
  veryHigh: 'none',
};
